<!--Buttons-->
<div class="row pr-3 pl-3">
  <div class="col-12 pr-0 pl-0 d-flex " [ngClass]="isNotMobile ? 'justify-content-between align-items-center': 'flex-column'">
    <div>
      <h2 class="pt-3" (click)="fakeMobile($event)">{{ 'Standard.Cases' | translate }}</h2>
    </div>
    <div class="d-flex align-items-center" [ngClass]="isNotMobile ? '' : 'justify-content-end'">
      <div class="text-right d-flex align-items-center">
        <div class="btn btn-sm btn-success mr-1 cursor-pointer" *ngFor="let x of filters.savedFilters" style="font-weight:100;">
          <span (click)="setFilter(x)">{{ x.name }} </span>
          <span class="ml-2"  (click)="filterDeleteName = x" data-toggle="modal" data-target="#deletePersonalFilter">x</span>
        </div>
        <button class="btn btn-sm btn-primary ml-2" (click)="getCurrentFilters()" data-toggle="modal" data-target="#savePersonalFilters" *ngIf="isNotMobile">{{ 'Buttons.SaveFilter' | translate }}</button>
      </div>
      <button class="btn btn-sm btn-outline-danger ml-3 mr-3" (click)="removeFilters()">{{ 'Buttons.ClearFilter' | translate }}</button>
      <button class="btn btn-sm btn-success mr-3" data-toggle="modal" data-backdrop='static' data-target="#createCaseModal">{{'Buttons.CreateCase' | translate}}</button>
    </div>
  </div>
</div>
<hr />

<!--Case Grid-->
<ag-grid-angular style="width:100%; height:calc(100vh - 10rem);"
                 #caseGrid
                 class="ag-theme-balham ag-theme-jublo"
                 [rowData]="cases"
                 [localeText]="gridTranslates"
                 [columnDefs]="tableColumns"
                 [defaultColDef]="defaultColumns"
                 [enableBrowserTooltips]="true"
                 [animateRows]="true"
                 [pagination]="true"
                 [paginationPageSize]="75"
                 [paginationAutoPageSize]="false"
                 [suppressPaginationPanel]="true"
                 [tooltipShowDelay]="1000"
                 [sideBar]="sidebar"
                 [statusBar]="statusBar"
                 [frameworkComponents]="frameworkComponents"
                 (sortChanged)="gridEvent($event)"
                 (filterChanged)="gridEvent($event)"
                 (dragStopped)="gridEvent($event)"
                 (paginationChanged)="gridEvent($event)"
                 (displayedColumnsChanged)="gridEvent($event)"
                 (cellClicked)="gridCellClicked($event)"
                 *ngIf="isNotMobile">
</ag-grid-angular>

<!--Case Grid Mobile-->
<div *ngIf="!isNotMobile && cases != null">
  <div class="row mobileCaseList mobileCaseContainer" *ngFor="let x of cases" [routerLink]="['/Details/' + x.caseId]" [ngClass]="getStatusClassByStatusId(x.status)">
      <div class="col-12 d-flex mb-2 justify-content-between mt-2">
        <div class="d-flex">
          <div class="mr-3">{{ getStatusTranslate(x.status) | translate  }}</div>
          <div *ngIf="x.caseNumber != null">{{ 'Standard.Case' | translate }} {{ x.caseNumber }}</div>
        </div>
        <div class="d-flex flex-column">
          <div class="d-flex"><b class="mr-1">{{ 'Standard.Responsible' | translate}}</b> {{ x.responsible }}</div>
          <div class="d-flex"><b class="mr-1">{{ 'Standard.Planned' | translate }}</b> {{ x.fitter }} {{ x.startTime != null ? (x.startTime + 'Z' | date:'dd-MM HH:mm') : '' }}</div>
        </div>
      </div>
      <div class="col-12 d-flex flex-column mb-2">
        <div>{{ x.title }}</div>
        <div class="card-description">{{ x.description }}</div>
      </div>
      <div class="col-12 mb-2 d-flex justify-content-between align-items-center">
        <div *ngIf="x.deliveryAddress == null && x.property == null">
          <b>{{ x.customer.name }}</b>
          <div>{{ x.customer.address }}, {{ x.customer.zipCode }} {{ x.customer.city }}</div>
        </div>
        <div *ngIf="x.deliveryAddress != null && x.property == null">
          <b>{{ x.deliveryAddress.name }}</b>
          <div>{{ x.deliveryAddress.address }}, {{ x.deliveryAddress.zipCode }} {{ x.deliveryAddress.city }}</div>
        </div>
        <div *ngIf="x.property != null">
          <b>{{ x.customer.name }}</b>
          <div class="d-flex">
            <div class="mr-1">{{ x.property.number }}</div>
            <div class="mr-1">{{ x.property.name }}</div>
            <div class="mr-1" *ngIf="x.lease != null">{{ x.lease.number }}</div>
            <div class="mr-1" *ngIf="x.lease != null">{{ x.lease.address }}</div>
          </div>
        </div>
        <div class="d-flex">
          <div><span style="margin-left:1.5rem;" *ngIf="x.unreadMessage"><i class="fas fa-envelope icons new-message text-danger"></i></span></div>
          <div><span style="margin-left:1.5rem;" *ngIf="x.unreadPartnerMessage"><i class="fas fa-envelope icons new-message text-primary"></i></span></div>
        </div>
      </div>
  </div>
</div>

<!-- Partner Cases Modal -->
<div class="modal fade" id="showPartnerCasesModal" tabindex="-1" role="dialog" aria-labelledby="showPartnerCasesModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header p-3">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 11L11 1M1 1L11 11" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
        </button>
      </div>
      <div class="modal-body p-3" *ngIf="partnerCasesList.length > 0">
        <div class="row">
          <div class="col-12">
            <ul class="nav nav-pills nav-custombg">
              <li class="nav-item" *ngFor="let x of partnerCasesList">
                <a class="nav-link" [ngClass]="partnerCases.caseId == x.caseId ? 'active' : ''" tabindex="0" (click)="partnerCases = x; getPartnerInfo(x.companyName)">{{ x.companyName }}</a>
              </li>
            </ul>
            <hr />
          </div>
          <div class="col-12" *ngIf="partnerInfo">
            <div class="row">
              <div class="col-4" *ngIf="partnerInfo.logo != null">
                <img class="img-responsive partner-image" src="https://app.jublo.com/api/shared/attachments/{{ partnerInfo.logo }}" alt="Partner logo" *ngIf="partnerInfo.logo.length == 36">
                <img class="img-responsive partner-image" src="{{ partnerInfo.logo }}" alt="Partner logo" *ngIf="partnerInfo.logo.length != 36">
              </div>
              <div class="col-4">
                <h3>{{ partnerInfo.companyName }}</h3>
                <p>{{ partnerInfo.address }}</p>
              </div>
              <div class="col-4">
                <h3>{{ 'Standard.ContactInfo' | translate }}</h3>
                <p>{{ partnerInfo.email }} • {{ partnerInfo.phone }}</p>
              </div>
            </div>
            <hr />
          </div>
          <div class="col-4" *ngIf="!!partnerCases">
            <div class="row">
              <div class="col-12">
                <!--CASE NUMBER-->
                <div class="row mb-3" *ngIf="partnerCases.caseNumber || partnerCases.externalId">
                  <div class="col-12">
                    <h2 *ngIf="partnerCases.caseNumber">{{ 'Cases.CaseNumber' | translate }}: {{ partnerCases.caseNumber }}</h2>
                    <h2 *ngIf="!partnerCases.caseNumber && partnerCases.externalId">{{ 'Cases.CaseNumber' | translate }}: {{ partnerCases.externalId }}</h2>
                  </div>
                </div>
                <!--STATUS-->
                <div class="row status-row mb-3">
                  <div class="col-12">
                    <h5 class="header__text"><b><i class="far fa-info-square align-top"></i> {{ ('CasesDetails.Status' | translate) | uppercase }}</b></h5>
                    <div>
                      <div class="badge" style="font-size:100%;padding:0.3rem 0.6rem;font-weight:100" [ngClass]="{'badge-success': partnerCases.status.name == 'CaseStatus.Name.Open' || partnerCases.status.name == 'CaseStatus.Name.Custom','badge-info': partnerCases.status.name == 'CaseStatus.Name.Closed','badge-secondary': partnerCases.status.name == 'CaseStatus.Name.Posted','badge-danger': partnerCases.status.name == 'CaseStatus.Name.Canceled', 'badge-primary':partnerCases.status.name == 'CaseStatus.Name.NeedPlanning'}">
                        {{ partnerCases.status.name | translate }}
                      </div>
                    </div>
                  </div>
                </div>
                <!--RESPONSIBLE-->
                <div class="row responsible-row mb-3" *ngIf="partnerCases.responsible.name != null">
                  <div class="col-12">
                    <h5>
                      <b><i class="far fa-user-hard-hat align-top"></i> {{ ('Standard.Responsible' | translate) | uppercase }}</b>
                    </h5>
                    <div>{{ partnerCases.responsible.name }}</div>
                  </div>
                </div>
                <!--DESCRIPTION-->
                <div class="row mb-3">
                  <div class="col-12">
                    <h5><b><i class="far fa-file-alt align-top"></i> {{ ('Standard.Description' | translate) | uppercase }}</b></h5>
                    <div [innerHTML]="partnerCases.description" *ngIf="isHTML(partnerCases.description)"></div>
                    <div class="stringDescription" *ngIf="!isHTML(partnerCases.description)">{{ partnerCases.description }}</div>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <!--FITTER TASK-->
                <div class="row executionTime-row mb-3" *ngIf="nextTask != null">
                  <div class="col-12">
                    <h5><b><i class="far fa-clock align-top"></i> {{ ('CasesDetails.ExecutionTime' | translate) | uppercase }}</b></h5>
                  </div>
                </div>
                <!--REQUISITION NUMBER-->
                <div class="row mb-3">
                  <div class="col-12">
                    <h5><b><i class="far fa-file-alt"></i> {{ 'CasesDetails.RequisitionNumber' | translate }}</b></h5>
                  </div>
                  <div class="col-12">
                    <p>{{ (partnerCases.requisitionNumber != null && partnerCases.requisitionNumber != '') ? partnerCases.requisitionNumber : ('Standard.NoRequisition' | translate) }}</p>
                  </div>
                </div>
                <!--REFERENCE NUMBER-->
                <div class="row mb-3">
                  <div class="col-12">
                    <h5><b><i class="far fa-file-alt"></i> {{ 'Standard.Reference' | translate }}</b></h5>
                  </div>
                  <div class="col-12">
                    <p>{{ (partnerCases.vorRef != null && partnerCases.vorRef != '') ? partnerCases.vorRef : ('Standard.NoReference' | translate) }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-4">
            <!--CUSTOMER ADDRESS-->
            <div class="row address-row mb-3">
              <div class="col-12 customer">
                <h5><b><i class="far fa-home-lg-alt align-top"></i> {{ ('Standard.CustomerAddress' | translate) | uppercase }}</b></h5>
                <div *ngIf="partnerCases.customer.name">{{ partnerCases.customer.name }}</div>
                <div>
                  <div *ngIf="partnerCases.customer.address">{{ partnerCases.customer.address }}</div>
                  <div *ngIf="partnerCases.customer.zipCode != null && partnerCases.customer.city != null">{{partnerCases.customer.zipCode}} {{partnerCases.customer.city}}</div>
                </div>
                <div *ngIf="partnerCases.customer.email">{{ partnerCases.customer.email }}</div>
                <div *ngIf="partnerCases.customer.phone">{{ partnerCases.customer.phone }}</div>
              </div>
            </div>
            <!--DELIVERY ADDRESS-->
            <div class="row address-row mb-3">
              <div class="col-12 customer">
                <h5><b><i class="far fa-home-lg-alt align-top"></i> {{ ('Standard.DeliveryAddress' | translate) | uppercase }}</b></h5>
                <div *ngIf="partnerCases.deliveryAddress.name">{{ partnerCases.deliveryAddress.name }}</div>
                <div>
                  <div *ngIf="partnerCases.deliveryAddress.address">{{ partnerCases.deliveryAddress.address }}</div>
                  <div *ngIf="partnerCases.deliveryAddress.zipCode != null && partnerCases.deliveryAddress.city != null">{{partnerCases.deliveryAddress.zipCode}} {{partnerCases.deliveryAddress.city}}</div>
                </div>
                <div *ngIf="partnerCases.deliveryAddress.email">{{ partnerCases.deliveryAddress.email }}</div>
                <div *ngIf="partnerCases.deliveryAddress.phone">{{ partnerCases.deliveryAddress.phone }}</div>
              </div>
            </div>
          </div>
          <div class="col-4">
            <!--FILES-->
            <div class="row mb-3">
              <div class="col-12 d-flex align-items-center">
                <h5><b><i class="far fa-paperclip align-top"></i> {{ ('Standard.Files' | translate) | uppercase }}</b></h5>
              </div>
              <div class="col-12 d-flex" *ngIf="!!partnerCases && !!partnerCases.files">
                <div *ngFor="let x of partnerCases.files">
                  <div>
                    <app-image-modal [id]="image + x.fileId" [images]="[x]"></app-image-modal>
                  </div>
                  <div class="figure-caption text-center" *ngIf="transferringFiles == false">
                    <input type="checkbox" class="form-control" style="height:1rem!important" (click)="addImageToTransfer($event,x.fileId)" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer p-3">
        <button class="btn btn-success" (click)="getFilesFromPartner()" *ngIf="transferImages.length > 0">{{ 'Standard.Transfer' | translate }}</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ 'Buttons.Close' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<!--CREATE CASE-->
<div id="createCaseModal" class="modal fade" tabindex="-1" role="dialog" data-target="local_modal" data-toggle="modal" aria-labelledby="modal" aria-hidden="true">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header p-3">
        <h5 class="modal-title" id="modal_title">{{ 'Buttons.CreateCase' | translate }}</h5>
        <button type="button" class="close" (click)="currentCase.step = 'chooseCustomer'" data-dismiss="modal" aria-label="Close">
          <i class="fa fa-window-close red" aria-hidden="true"></i>
        </button>
      </div>
      <div class="modal-body p-3">
        <app-customer-address [(step)]="currentCase.step" (choose)="createCaseChooseCustomer($event)" (com)="pageTurner($event)" [do]="customerComponentMessage" (update)="newCaseCustomerChanged($event)"></app-customer-address>
        <div class="row mb-3" *ngIf="currentCase.step == 'final'">
          <div class="col-12 mb-3" *ngIf="customerComponentData != null && customerComponentData.leases != null && customerComponentData.leases.length > 0">
            <label>{{ 'Properties.Lease' | translate }}</label>
            <select class="form-control" [(ngModel)]="currentCase.propertyLeaseId">
              <option [ngValue]="null">{{ 'Standard.NoneChosen' | translate}}</option>
              <option *ngFor="let x of customerComponentData.leases" [value]="x.propertyLeaseId">{{ x.address }}</option>
            </select>
          </div>
          <div class="col-12 mb-3">
            <label>{{ 'Standard.Title' | translate }}</label>
            <input type="text" [(ngModel)]="currentCase.title" class="form-control" />
          </div>
          <div class="col-12 mb-3">
            <label class="mb-0" for="OfferDescription">{{ 'Standard.Description' | translate }} *</label>
            <textarea class="form-control" rows="4" type="text" [(ngModel)]="currentCase.description" id="OfferDescription"></textarea>
          </div>
          <div class="col-6">
            <label class="mb-0">{{ 'Standard.Reference' | translate }}</label>
            <input type="text" [(ngModel)]="currentCase.vorRef" class="form-control" />
          </div>
          <div class="col-6">
            <label class="mb-0">{{ 'CasesDetails.RequisitionNumber' | translate }}</label>
            <input type="text" [(ngModel)]="currentCase.requisitionNumber" class="form-control" />
          </div>
          <div class="col-6 mt-3 align-self-center">
            <div class="form-inline form-inline-sm">
              <span class="slider-text">{{ 'Standard.TurnNotification' | translate }} {{ currentCase.disableNotification ? (( 'Standard.Off' | translate ) | lowercase) : (( 'Standard.On' | translate) | lowercase)  }}</span>
              <label class="switch ml-4">
                <input type="checkbox" [(ngModel)]="currentCase.disableNotification">
                <span class="slider round"></span>
              </label>
            </div>
          </div>
          <div class="col-6 mt-3">
            <label class="mb-0">{{ 'Standard.CaseResponsible' | translate }}</label>
            <select class="form-control" [(ngModel)]="currentCase.responsibleId">
              <option [ngValue]="null">{{ 'Standard.NoneChosen' | translate }}</option>
              <option *ngFor="let x of responsibles" [value]="x.key">{{x.value}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary mr-auto" (click)="currentCase.step = previousStep;customerComponentMessage = 'back'" *ngIf="currentCase.step != 'chooseCustomer'">{{ 'Buttons.Back' | translate }}</button>
        <button type="button" class="btn btn-outline-success" (click)="currentCase.step = 'final'; getPreviousFromCurrent(); customerComponentMessage = 'editCustomer'" *ngIf="currentCase.step == 'editCustomer'">{{ 'Buttons.Save' | translate }}</button>
        <button type="button" class="btn btn-outline-success" (click)="currentCase.step = 'final'; getPreviousFromCurrent(); customerComponentMessage = 'createCustomer'" *ngIf="currentCase.step == 'newCustomer'">{{ 'Buttons.CreateCustomer' | translate }}</button>
        <button type="button" class="btn btn-outline-success" (click)="currentCase.step = 'final'; getPreviousFromCurrent(); customerComponentMessage = 'chooseDelivery'" *ngIf="currentCase.step == 'chooseDelivery'">{{ 'Standard.Choose' | translate }}</button>
        <button type="button" class="btn btn-outline-success" (click)="currentCase.step = 'final'; getPreviousFromCurrent(); customerComponentMessage = 'chooseContact'" *ngIf="currentCase.step == 'chooseContact'">{{ 'Standard.Choose' | translate }}</button>
        <button type="button" class="btn btn-outline-success" (click)="currentCase.step = 'final'; getPreviousFromCurrent(); customerComponentMessage = 'chooseCustomer'" *ngIf="currentCase.step == 'chooseCustomer'" [disabled]="currentCase.customerId == null">{{ 'Buttons.Next' | translate }}</button>
        <button class="btn btn-outline-success" (click)="createCase()" data-dismiss="modal" *ngIf="currentCase.step == 'final'" [disabled]="currentCase.description == ''">{{'Buttons.CreateCase' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<!--Save Personal Filter-->
<div class="modal fade" id="savePersonalFilters" tabindex="-1" role="dialog" aria-labelledby="newActivityModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="newActivityModalLabel">{{ 'Buttons.SaveFilter' | translate }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 11L11 1M1 1L11 11" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
        </button>
      </div>
      <div class="modal-body">
        <label>{{ 'Standard.Name' | translate }}</label>
        <input type="text" [(ngModel)]="filterSaveName" class="form-control" />
      </div>
      <div class="modal-footer">
        <button class="btn btn-success" (click)="savePersonalFilter()" data-dismiss="modal">{{ 'Buttons.Save' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<!--Delete Filter Modal-->
<div class="modal fade" id="deletePersonalFilter" tabindex="-1" role="dialog" aria-labelledby="deletePersonalFilterLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deletePersonalFilterLabel">{{ 'Standard.DeleteConfirmation.Text' | translate }}: {{ filterDeleteName?.name }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 11L11 1M1 1L11 11" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
        </button>
      </div>
      <div class="modal-footer">
        <button class="btn btn-danger" (click)="deletePersonalFilter(filterDeleteName)" data-dismiss="modal">{{ 'Buttons.Delete' | translate }}</button>
      </div>
    </div>
  </div>
</div>
